const tagsView = {
  refresh: "Refresh",
  close: "Close",
  closeOthers: "Close Others",
  closeAll: "Close All"
} 
export default tagsView